import { SummaryDateLine } from './SummaryDateLine';
import { NeedDto, UserDto } from '@act/shared/data-transfer-objects';
import { timeFormatter } from '@act/shared/utilities';
import { Dictionary } from '@act/shared/types';

interface NeedSummaryDateLineProps {
  need: NeedDto;
  userMap?: Dictionary<UserDto>;
}

export const NeedSummaryDateLine = ({
  need,
  userMap,
}: NeedSummaryDateLineProps) => {
  let actorName: string;

  if (need.fulfilledAt) {
    actorName = userMap?.[need.closedById]?.name;
  } else {
    actorName = userMap?.[need.creatorId]?.name;
  }

  const action = need.fulfilledAt ? 'Fulfilled' : 'Identified';
  const datetime = need.fulfilledAt ? need.fulfilledAt : need.identifiedAt;

  const text = `${action} on ${timeFormatter.epochToHumanReadableDate({
    date: datetime,
    showFullMonthName: true,
    excludeRelativeDay: true,
  })} by ${actorName}`;

  return <SummaryDateLine text={text} />;
};
